module.exports = __webpack_public_path__ + "static/chordsl-ebe9c65dbc8d2bf7e48192c66e76d6f4.png";